module.exports = __webpack_public_path__ + "img/daotianIcon.1541820c.svg";